import {
	AccountListItemProps,
	Typography,
	Image,
	Spacer,
	Box,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { AvailableAccount } from './availableAccountList';
import { avatarLogoBcp } from '@icons';
import { rem } from '@helpers';
import { FormatHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { Company } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';

export const useAvailableAccountListHelper = (availableAccounts: AvailableAccount[]) => {
	const accountListItems: AccountListItemProps[] = availableAccounts.map((account) => {
		return {
			variant: 'light',
			backgroundColor: 'transparent',
			startContent: {
				content: (
					<>
						<Spacer horizontal={rem(4)} />
						<Image
							source={account.avatar || avatarLogoBcp}
							svgProps={{
								height: 32,
								width: 32,
							}}
						/>
						<Spacer horizontal={rem(20)} />
						<Box styles={{ width: rem(182) }}>
							<Typography appearance="body-75-02">
								{FormatHelper.formatAccountNumber(account.number, Company.ab)}
							</Typography>
						</Box>
					</>
				),
				containerProps: { marginRight: '0px' },
			},
			middleContent: {
				otherContent: <Typography appearance="body-75-02">{account.name}</Typography>,
				containerProps: { marginLeft: '0px' },
			},
			endContent: {
				content: <Typography appearance="body-75-02">{FormatHelper.formatIban(account.iban)}</Typography>,
			},
			paddingTop: '.5rem',
			paddingBottom: '.5rem',
		} as AccountListItemProps;
	});

	return { accountListItems };
};
